pageLoad('animes_files', 'mangas_files', () => {
  $('.b-options-floated.collapse').trigger('click');
});
